/* eslint-disable prefer-const */
import React, { useState, useEffect } from "react";

import moment from "moment";
import { useTranslation } from "react-i18next";

import { datesAreSame, compareDate } from "../../../../../helpers/helpers";
import { Quote } from "../../../../../models/quote";
import { Task } from "../../../../../models/task";
import QuoteBox from "./Box";
import useStyles from "./styles";
import "./index.scss";

interface TaskState extends Task {
  quote: Quote;
}

interface QuoteActions {
  handleEdit: (id: number | string) => void;
  handleStartVideoSurvey: (tasks: Task[]) => void;
  handleApprove: (id: number | string) => void;
  handleDecline: (id: number | string) => void;
  handleCommunication: (id: number | string) => void;
}
interface Props {
  actions: QuoteActions;
  quotes: Quote[];
}

function QuoteCalendar({ actions, quotes }: Props) {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const daysOfWeek = [
    translate("sunday"),
    translate("monday"),
    translate("tuesday"),
    translate("wednesday"),
    translate("thursday"),
    translate("friday"),
    translate("saturday"),
    translate("sunday"),
  ];
  const months = [
    translate("january"),
    translate("february"),
    translate("march"),
    translate("april"),
    translate("may"),
    translate("june"),
    translate("july"),
    translate("august"),
    translate("september"),
    translate("october"),
    translate("november"),
    translate("december"),
  ];

  const [tasks, setTasks] = useState<TaskState[]>([]);
  const [days, setDays] = useState<Date[]>([]);

  useEffect(() => {
    if (quotes) {
      let dates: Date[] = [];
      const now = new Date();

      const taskList: any[] = [];

      for (let quote of quotes) {
        for (let task of quote.tasks) {
          taskList.push({
            ...task,
            job: quote,
          });
          const findDateSame = dates.find((d) => datesAreSame(d, new Date(task.startDate)));

          if (!findDateSame) {
            dates.push(new Date(task.startDate));
          }
        }
      }
      setTasks(taskList);

      dates = dates.filter((d) => {
        now.setHours(0, 0, 0, 0);
        const compare = compareDate(now, d);

        return compare >= 0;
      });
      dates = dates.sort((a, b) => {
        return a.getTime() - b.getTime();
      });
      setDays(dates);
    }
  }, [quotes]);

  return (
    <>
      {days.length <= 0 && (
        <div className={classes.mainDiv}>
          <span className={classes.text}>{translate("noInformationToBeShown")}</span>
        </div>
      )}
      <div className="d-flex flex-column">
        <div className="quote-calendar-container">
          {days.map((day, i) => (
            <div key={i} className={classes.box}>
              <span className={classes.title}>
                {daysOfWeek[moment(day).isoWeekday()]}, {day.getDate()} {months[day.getMonth()]}{" "}
                {day.getFullYear()}
              </span>

              <div className="quote-calendar-box">
                {tasks.map((task, index) => {
                  const startDate = new Date(task.startDate);

                  if (isNaN(startDate.getDate())) return null;
                  if (datesAreSame(startDate, day)) {
                    return (
                      <div key={Math.random()} style={{ gridTemplateRows: "1fr" }}>
                        <QuoteBox quote={task.job} task={task} actions={actions} />
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default QuoteCalendar;
